import ActionType from '../action';

export function setTheme(payload) {
  return ({ type: ActionType.CHANGE_THEME_CONFIG, payload});
}

export default {
  setTheme
}
